angular.module('checkout').directive(
    'discountPercentSelect', [
        'orderMgr', 'rcmEventManager', function (orderMgr, rcmEventManager) {
            function link($scope) {
                $scope.showWarningModal = false;

                /**
                 * Loads only the values this direct needs from a given order
                 *
                 * Doing this instead of just using the given order helps
                 * the warning popup and select box stay in-sync on edge cases
                 * @param order
                 */
                function loadOrder(order) {
                    $scope.alertWhenCanSelectHigherDiscount = order.attributes.alertWhenCanSelectHigherDiscount;
                    $scope.discountPercent = order.discountPercent;
                    $scope.allowedDiscountPercents = order.attributes.allowedDiscountPercents;
                    $scope.defaultDiscountPercent = order.attributes.defaultDiscountPercent;
                }

                /**
                 * Returns true if the given array of objects contains an object with the
                 * given property value.
                 *
                 * @param array
                 * @param propertyName
                 * @param propertyValue
                 * @returns {boolean}
                 */
                function arrayContainsObjectWithPropertyValue(array, propertyName, propertyValue) {
                    for (let i = 0; i < array.length; i++) {
                        if (array[i][propertyName] == propertyValue) {
                            return true;
                        }
                    }
                    return false;
                }

                /**
                 * Ensure the order in our scope always equals the current order
                 */
                rcmEventManager.on(
                    'orderMgr.orderChange',
                    function (order) {
                        loadOrder(order);
                        //Prevent the discount select from becoming blank when products are removed in US.
                        if (
                            !arrayContainsObjectWithPropertyValue(
                                order.attributes.allowedDiscountPercents,
                                'value',
                                $scope.discountPercent
                            )
                        ) {
                            //console.log(order.attributes.allowedDiscountPercents, $scope.discountPercent, $scope.defaultDiscountPercent);
                            orderMgr.setDiscountPercent($scope.defaultDiscountPercent);
                        }
                    }
                );

                /**
                 * If they select a higher discount percent than their default,
                 * they must pass through a warning modal, confirming this is
                 * what they really want.
                 */
                $scope.onDiscountPercentChange = function () {
                    if ($scope.discountPercent > $scope.defaultDiscountPercent) {
                        $scope.showWarningModal = true;
                    } else {
                        orderMgr.setDiscountPercent($scope.discountPercent);
                    }
                };

                /**
                 * When user clicks "cancel" on the warning modal, ignore their
                 * changes.
                 */
                $scope.warningModalCancel = function () {
                    //Reset this directive's order ignoring our changes
                    loadOrder(orderMgr.getOrder());
                    $scope.showWarningModal = false;
                };

                /**
                 * When user clicks "continue" on the warning modal, send their
                 * changes to the order manager for saving.
                 */
                $scope.warningModalContinue = function () {
                    orderMgr.setDiscountPercent($scope.discountPercent);
                    $scope.showWarningModal = false;
                };
            }

            return {
                link: link,
                template: `
                    <tr class="discountPercentSelected" ng-show="alertWhenCanSelectHigherDiscount && discountPercent < defaultDiscountPercent">
                        <td colspan="2">
                            <div class="alert alert-warning">{{'You can select a higher discount'|translate}}</div>
                        </td>
                    </tr>
                    <tr class="discountPercentSelected">
                        <td>
                            {{'Discount Level' | translate}}
                        </td>
                        <td class="money discountPercent">
                            <select ng-change="onDiscountPercentChange()"
                                    ng-model="discountPercent"
                                    ng-options="item.value as item.label for item in allowedDiscountPercents"></select>
                            <div class="modal" ng-class="{show:showWarningModal}">
                                <div class="modal-dialog">
                                    <div class="modal-content">
                                        <div class="modal-body" style="text-align: left">
                                            <p>
                                        <span style="white-space:normal;"
                                              ng-bind="'Before selecting a higher discount level, please verify you meet the necessary requirements with your sponsor. Your current discount level is:' | translate"></span>
                                                <span ng-bind="defaultDiscountPercent + '%'"></span>
                                            </p>
                                        </div>
                                        <div class="modal-footer">
                                            <button type="button" class="btn btn-default" ng-click="warningModalContinue()"
                                                    ng-bind="'Continue with higher discount level' | translate">
                                            </button>
                                            <button type="button" class="btn btn-primary" ng-click="warningModalCancel()"
                                                    ng-bind="'Cancel' | translate">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>
                `,
            };
        },
    ]
)
;
